

export class ESICDto implements IESICDto {
    id!: number | undefined;
    yearMonth!: string | undefined;
    monthDate!: Date;
    fromAmount!: number;
    toAmount!: number;
    companyPer!: number;
    employeePer!: number;

    constructor(data?: IESICDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.yearMonth = _data["yearMonth"];
            this.monthDate = _data["monthDate"] ? new Date(_data["monthDate"].toString()) : <any>undefined;
            this.fromAmount = _data["fromAmount"];
            this.toAmount = _data["toAmount"];
            this.companyPer = _data["companyPer"];
            this.employeePer = _data["employeePer"];
        }
    }

    static fromJS(data: any): ESICDto {
        data = typeof data === 'object' ? data : {};
        let result = new ESICDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["yearMonth"] = this.yearMonth;
        data["monthDate"] = this.monthDate ? this.monthDate.toISOString() : <any>undefined;
        data["fromAmount"] = this.fromAmount;
        data["toAmount"] = this.toAmount;
        data["companyPer"] = this.companyPer;
        data["employeePer"] = this.employeePer;
        return data; 
    }
}

export interface IESICDto {
    id: number | undefined;
    yearMonth: string | undefined;
    monthDate: Date;
    fromAmount: number;
    toAmount: number;
    companyPer: number;
    employeePer: number;
}

